export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10098.b4d35494.jpg";